import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = ({ tip = 'Chargement...', size = 'large' }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '80px 20px',
    minHeight: 300,
  }}>
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: size === 'large' ? 40 : 24, color: '#059669' }} spin />}
      tip={tip}
      size={size}
    >
      <div style={{ padding: 50 }} />
    </Spin>
  </div>
);

export default LoadingSpinner;
